import { useQuery } from '@tanstack/react-query';
import { DATASET_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_dataset_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { Dataset } from '@/types/datasets.ts';

const useRetrieveDataset = (datasetId?: string) => {
  const apiClient = useApiClient();

  return useQuery<Dataset, AxiosError>({
    queryKey: DATASET_KEY(datasetId || ''),
    enabled: !!datasetId,
    queryFn: async () => {
      if (!datasetId) throw new Error('Dataset ID is required');
      const response = await apiClient.get<Dataset>(get_dataset_url(datasetId));
      return response.data;
    },
  });
};

export default useRetrieveDataset;
